import Button from 'components/Button/Button';
import Input from 'components/Input/Input';
import { Spacer } from 'components/Layout';
import { FilterDetail, useFilter } from 'features/filter';
import { OrderFilterItem, OrderFilterKeys } from 'features/order-filter/types';
import { MouseEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CustomerFilter = () => {
  const { t } = useTranslation(['translation', 'orders']);
  const [value, setValue] = useState('');
  const { setFilter, resetFilterByKey, filter } = useFilter<
    OrderFilterKeys,
    OrderFilterItem
  >();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSubmit = (
    e: MouseEvent<HTMLButtonElement & HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    setFilter('customerName', [{ name: value, id: encodeURIComponent(value) }]);
  };

  const handleClear = () => {
    setValue('');
    resetFilterByKey('customerName');
  };

  useEffect(() => {
    if (filter?.customerName?.[0].name !== value) {
      setValue('');
    }
  }, [filter?.customerName]);

  return (
    <FilterDetail>
      <Spacer tag="p" className="small" marginBottom={2}>
        {t('orders:filter.customerName.description')}
      </Spacer>
      <form>
        <div className="">
          <Input
            value={value}
            onChange={handleChange}
            name="customerName"
            placeholder={t('orders:filter.customerName.placeholder')}
            label={t('orders:filter.customerName.label')}
            onClear={handleClear}
          />
        </div>
        <Spacer marginTop={2}>
          <Button
            text={t('orders:filter.customerName.button')}
            onClick={handleSubmit}
            type="submit"
            disabled={value.length < 3}
          />
        </Spacer>
      </form>
    </FilterDetail>
  );
};

export default CustomerFilter;
